'use client'
import { Select, SelectItem, SelectProps } from '@nextui-org/select'
import { SelectSlots, SlotsToClasses } from '@nextui-org/theme'

import { ChangeEventHandler, FC } from 'react'

import { IconStrongArrow } from '@/app/shared/icons'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import { styles, stylesOption } from '@/app/shared/ui/select/constants'
import { getColor } from '@/app/shared/ui/select/services'

// interface
interface ISelect extends IClassName, Omit<SelectProps, 'children' | 'isRequired'> {
  value?: string
  onChange?: ChangeEventHandler<HTMLSelectElement> | undefined
  stylesSelect?: SlotsToClasses<SelectSlots>
  option: {
    value: string
    label: string
  }[]
  colorType?: string
}

const SelectComponent: FC<Readonly<ISelect>> = ({
  className,
  option,
  onChange,
  value,
  stylesSelect,
  colorType,
  ...props
}) => {
  const currentStyle = stylesSelect ?? (colorType ? getColor(colorType) : styles)

  return (
    <Select
      {...props}
      aria-label={'select'}
      variant={'underlined'}
      className={className}
      classNames={{ ...currentStyle }}
      selectorIcon={<IconStrongArrow />}
      onChange={onChange}
      selectedKeys={[value ?? '']}
      listboxProps={{ itemClasses: { ...stylesOption } }}
      disallowEmptySelection
      scrollShadowProps={{
        isEnabled: false,
      }}
      maxListboxHeight={400}
    >
      {option.map((el) => (
        <SelectItem key={el.value}>{el.label}</SelectItem>
      ))}
    </Select>
  )
}

export default SelectComponent
